import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
const KEY = "bc_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const addItem = (item) => {
    setItems((prev) => {
      const idx = prev.findIndex(
        (p) => p.product_id === item.product_id && p.size === item.size && p.color === item.color
      );
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx].qty += item.qty;
        return copy;
      }
      return [...prev, item];
    });
    toast.success("Added to bag", { description: `${item.name} · ${item.size || "One size"}` });
  };

  const updateQty = (i, qty) =>
    setItems((prev) => prev.map((p, idx) => (idx === i ? { ...p, qty: Math.max(1, qty) } : p)));
  const removeItem = (i) => setItems((prev) => prev.filter((_, idx) => idx !== i));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
